(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gg-blowout-sale"] && !Shopify.designMode) return;
  try {
    (()=>{
    function update(){
      const now=Date.now();
      document.querySelectorAll('[data-gg-blowout]').forEach(root=>{
        const start=Number(root.dataset.start)*1000,end=Number(root.dataset.end)*1000;
        if(!Number.isFinite(start)||!Number.isFinite(end)||now<start||now>=end){root.hidden=true;return;}
        root.hidden=false;
        const left=Math.ceil((end-now)/1000);
        const values={hours:Math.floor(left/3600),minutes:Math.floor(left%3600/60),seconds:left%60};
        Object.entries(values).forEach(([unit,value])=>{const node=root.querySelector('[data-blowout-'+unit+']');if(node)node.textContent=String(value).padStart(2,'0');});
        const clock=root.querySelector('.gg-blowout__clock');if(clock)clock.hidden=false;
        const date=root.querySelector('[data-blowout-deadline]');if(date&&!date.dataset.formatted){date.textContent=new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',hour:'numeric',minute:'2-digit',timeZone:'America/New_York',timeZoneName:'short'}).format(new Date(end));date.dataset.formatted='true';}
      });
    }
    update();setInterval(update,1000);document.addEventListener('visibilitychange',update);document.addEventListener('shopify:section:load',update);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-spooktacular-banner"] && !Shopify.designMode) return;
  try {
    (() => { function expireStrips() {document.querySelectorAll('[data-gg-spook-strip]').forEach(root => {if (Date.now() >= Number(root.dataset.end) * 1000) root.hidden = true;});} expireStrips(); setInterval(expireStrips, 1000); })();
  } catch(e) { console.error(e); }
})();

})();
